import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { BrokerService } from '@c4/core';

import { Device } from '../../../common/interfaces/item.interface';
import { Command } from '../../../common/params/interfaces/command.interface';
import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';
import { SharedProgrammingService, CommandData, } from '../../../common/services/shared-programming.service';
import { CommandType, Criteria } from '../command-types/command-type.interface';
import { CommandTypes } from '../command-types/command-types';
import { SimpleProgrammingContext } from '../quickstart-simple.service';

@Component({
  templateUrl: './select-action.component.html',
  styleUrls: ['../select-device/select-device.component.less']
})
export class QSSimpleSelectActionComponent extends BaseRoutingComponent {

  private _device: Observable<Device>;
  private _commandType: Observable<CommandType>;
  private _whitelist: Observable<Criteria>;
  private _commands: Observable<Command[]>;

  constructor(
    public router: Router,
    private _route: ActivatedRoute,
    protected store: Store<{
      simpleProgramming: SimpleProgrammingContext
    }>,
    private _broker: BrokerService,
    private _shared: SharedProgrammingService
  ) {
    super();

    this._device = Observable.combineLatest(
      this._route.params.map((params: { id: string }) => parseInt(params.id)),
      this.store.select(s => s.simpleProgramming.devices).filter(d => !!d),
      (id, devices) => devices.find(d => d.id == id)
    );

    this._commandType = this._device
      .filter(d => !!d)
      .map(d => d.proxy)
      .map(proxy => CommandTypes.find(ct => ct.whitelist.map(w => w.proxy).indexOf(proxy) > -1));

    this._whitelist = Observable.combineLatest(
      this._device.filter(d => !!d),
      this._commandType,
      (device, type) => type.whitelist.find(wl => wl.proxy == device.proxy)
    );

    this._commands = Observable.combineLatest(
      this._device.filter(d => !!d),
      this._whitelist
    ).flatMap(([device, whitelist]) => <Promise<Command[]>>this._broker.call({
      path: `/api/v1/items/${device.id}/commands`,
      queryString: {
        query: {
          command: {
            '$in': whitelist.commands.map(c => c.command)
          }
        }
      }
    }))
      .share();
  }

  private _selectAction = (command: Command): void => {
    if (!!command.params && command.params.length > 0) {
      this.router.navigate(['../' + command.deviceId, command.command], {
        relativeTo: this._route
      })
    } else {
      this._shared.saveAction(command);
    }
  }

  private _getIcon = (command: Command): Observable<string> => {
    return this._whitelist.map(w => w.commands.find(c => c.command == command.command).icon);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/select-action/select-action.component.ts